module.exports = __webpack_public_path__ + "static/media/background-outside-branch.6ac20135.png";